export default {"src":"/_next/static/media/dota.e18987fe.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};